import { Button } from "@/components/ui/button";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

// IMPORT COMPONENTS
import { Checkbox } from "@/components/ui/checkbox";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Label } from "@/components/ui/label";
import { SliderMulti } from "@/components/ui/slider-multi";

// IMPORTS
import { filterResult } from "@/src/helpers/filterFlightList";
import { filteredFilters } from "@/src/helpers/flightFilters";
import { setFlightFilters } from "@/src/actions/flightAction";

const FilterFlights = ({
  filteredFlightList,
  flightList,
  filterTimes,
  flightFilters,
  setShowFilterCallback
}) => {
  const allFlightList = flightList;
  const dispatch = useDispatch();
  const [selectedAirlines, setSelectedAirlines] = useState([]);
  const [selectedDepartureDates, setSelectedDepartureDates] = useState([]);
  const [selectedArrivalDates, setSelectedArrivalDates] = useState([]);
  const [sliderValue, setSliderValue] = useState([0, 0]);
  const [selectedStops, setSelectedStops] = useState([]);
  const [committingMinPrice, setCommittingMinPrice] = useState(0);
  const [committingMaxPrice, setCommittingMaxPrice] = useState(0);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(0);
  const [stopsArr, setStopsArr] = useState([]);
  const handleChangeFilterCheckbox = (from, item, isChecked) => {
    switch (from) {
      case "airline":
        if (isChecked) {
          setSelectedAirlines((pre) => [...pre, item]);
        } else {
          setSelectedAirlines((current) =>
            current.filter((selectedAirline) => {
              return selectedAirline !== item;
            })
          );
        }
        break;

      case "departure":
        if (isChecked) {
          setSelectedDepartureDates((pre) => [...pre, item]);
        } else {
          setSelectedDepartureDates((current) =>
            current.filter((date) => {
              return date !== item;
            })
          );
        }
        break;

      case "arrival":
        if (isChecked) {
          setSelectedArrivalDates((pre) => [...pre, item]);
        } else {
          setSelectedArrivalDates((current) =>
            current.filter((date) => {
              return date !== item;
            })
          );
        }
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    filterResult(
      flightList,
      selectedAirlines,
      selectedDepartureDates,
      selectedArrivalDates,
      committingMinPrice,
      committingMaxPrice,
      selectedStops,
      dispatch
    );
  }, [
    selectedAirlines,
    selectedDepartureDates,
    selectedArrivalDates,
    committingMinPrice,
    committingMaxPrice,
    selectedStops,
  ]);
  // this resets the filters when search is perfomed form the flight list page
  useEffect(() => {
    setSelectedAirlines([]);
    setSelectedDepartureDates([]);
    setSelectedArrivalDates([]);
    setSelectedStops([]);
    setStopsArr([]);
  }, [flightList]);

  useEffect(() => {
    dispatch(
      setFlightFilters(filteredFilters(flightList, filterTimes), (resp) => {
        var minPrice = resp.MinPrice;
        var maxPrice = resp.MaxPrice;
        setCommittingMinPrice(minPrice);
        setMinPrice(minPrice);
        setCommittingMaxPrice(maxPrice);
        setMaxPrice(maxPrice);
        setSliderValue([minPrice, maxPrice]);
        let stops = [];
        for (let i = 0; i < resp.Stops; i++) {
          switch (i) {
            case 0:
              stops.push({ name: "Non-Stop", stops: i, checked: false });
              break;
            case 1:
              stops.push({ name: "1 Stop", stops: i, checked: false });
              break;
            default:
              stops.push({ name: i + " Stops", stops: i, checked: false });
          }
        }
        setStopsArr(stops);
        filterResult(
          flightList,
          [],
          [],
          [],
          minPrice,
          maxPrice,
          [],
          dispatch
        );
      })
    );
  }, [flightList]);

  const handleShowAllClick = () => {
    setSelectedAirlines([]);
    setSelectedArrivalDates([]);
    setSelectedDepartureDates([]);
    setCommittingMinPrice(minPrice);
    setCommittingMaxPrice(maxPrice);
    setSliderValue([minPrice, maxPrice]);
    setSelectedStops([]);
    setStopsArr((prevVal) =>
      prevVal.map((stop) => {
        return { ...stop, checked: false };
      })
    );
  };

  const handleChangeCheckbox = (isChecked, item) => {
    var latestStops = [...selectedStops];
    if (isChecked) {
      setStopsArr(
        stopsArr.map((stop) => {
          return { ...stop, checked: stop == item || stop.checked };
        })
      );
      if (!selectedStops.includes(item.stops)) {
        latestStops.push(item.stops);
        setSelectedStops(latestStops);
      }
    } else {
      setStopsArr(
        stopsArr.map((stop) => {
          return { ...stop, checked: stop == item ? false : stop.checked };
        })
      );
      setSelectedStops(latestStops.filter((f) => f != item.stops));
    }
  };
  return (
    flightFilters && (
      <>
        <div className="p-3 lg:p-0 flex-1 overflow-auto">
          <div className="text-xs">
            <div className="flex items-center justify-between">
              <p>
                <b>{filteredFlightList.length}</b> of <b>{allFlightList.length}</b>{" "}
                flights
              </p>
              <Button variant="link" onClick={handleShowAllClick}>
                <i>Show All</i>
              </Button>
            </div>
            <Accordion type="multiple" className="w-full">
              <AccordionItem value={"item1"}>
                <AccordionTrigger>Airlines</AccordionTrigger>
                {flightFilters.Airline.map((flight, i) => {
                  return (
                    <AccordionContent key={flight.FlightCode + "_key" + i}>
                      <div className="flex items-center space-x-2 pb-2">
                        <Checkbox
                          checked={
                            selectedAirlines.filter(
                              (sa) => sa.FlightCode == flight.FlightCode
                            ).length > 0
                          }
                          id={flight.FlightName}
                          onCheckedChange={(value) => {
                            handleChangeFilterCheckbox("airline", flight, value);
                          }}
                        />
                        <span
                          htmlFor={flight.FlightName}
                          className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          {flight.FlightName} ({flight.FlightCode})
                        </span>
                      </div>
                    </AccordionContent>
                  );
                })}
              </AccordionItem>
              <AccordionItem value={"item2"}>
                <AccordionTrigger>Departure Time</AccordionTrigger>
                {flightFilters.FilterTimes.map((time, i) => {
                  return (
                    <AccordionContent key={time.Name + "_key" + i}>
                      <div className="flex items-center space-x-2 pb-2">
                        <Checkbox
                          checked={
                            selectedDepartureDates.filter(
                              (sa) => sa.Name == time.Name
                            ).length > 0
                          }
                          id={time.Name}
                          onCheckedChange={(value) => {
                            handleChangeFilterCheckbox("departure", time, value);
                          }}
                        />
                        <span
                          htmlFor={time.Name}
                          className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          {`${time.Name} (${time.From} - ${time.To}) `}
                        </span>
                      </div>
                    </AccordionContent>
                  );
                })}
              </AccordionItem>
              <AccordionItem value={"item3"}>
                <AccordionTrigger>Arrival Time</AccordionTrigger>
                {flightFilters.FilterTimes.map((time, i) => {
                  return (
                    <AccordionContent key={time.Name + "_key" + i}>
                      <div className="flex items-center space-x-2 pb-2">
                        <Checkbox
                          checked={
                            selectedArrivalDates.filter(
                              (sa) => sa.Name == time.Name
                            ).length > 0
                          }
                          id={time.Name + "arrival"}
                          onCheckedChange={(value) => {
                            handleChangeFilterCheckbox("arrival", time, value);
                          }}
                        />
                        <span
                          htmlFor={time.Name + "arrival"}
                          className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          {`${time.Name} (${time.From} - ${time.To}) `}
                        </span>
                      </div>
                    </AccordionContent>
                  );
                })}
              </AccordionItem>
            </Accordion>
            {flightFilters && flightFilters.MaxPrice > 0 && (
              <div>
                <span className="flex flex-1 items-center justify-between py-4 font-medium">
                  Price Range
                </span>
                <SliderMulti
                  className="SliderRoot"
                  defaultValue={[flightFilters.MinPrice, flightFilters.MaxPrice]}
                  min={flightFilters.MinPrice}
                  max={flightFilters.MaxPrice}
                  orientation="horizontal"
                  onValueChange={(val) => {
                    setSliderValue(val);
                  }}
                  value={sliderValue}
                  onValueCommit={(val) => {
                    setCommittingMinPrice(val[0]);
                    setCommittingMaxPrice(val[1]);
                  }}
                  minStepsBetweenThumbs={100}
                ></SliderMulti>
                <div className="flex justify-between pt-4 text-xs">
                  <span>{flightFilters.Currency + " " + sliderValue[0]}</span>
                  <span>{flightFilters.Currency + " " + sliderValue[1]}</span>
                </div>
              </div>
            )}
            {stopsArr && stopsArr.length > 0 && (
              <>
                <div className=" pt-3 font-medium">
                  Stops
                </div>
                {stopsArr.map((item, i) => (
                  <div className="pt-2" key={i}>
                    <div className="flex items-center space-x-2 pb-2">
                      <Checkbox
                        checked={item.checked}
                        value={item.checked}
                        id={item.stops}
                        onCheckedChange={(value) => {
                          handleChangeCheckbox(value, item);
                        }}
                      />
                      <span
                        htmlFor={item.stops}
                        className="leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                      >
                        {item.name}
                      </span>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        <div className="flex lg:hidden items-center shadow border-t p-3 gap-x-3 justify-end">
          <Button variant="secondary" className="" onClick={handleShowAllClick}>
            Clear Filter
          </Button>
          <Button className="" onClick={() => {
            setShowFilterCallback && setShowFilterCallback(false);
          }}>Apply</Button>
        </div>
      </>
    )
  );
};

export default FilterFlights;
